export const storeUserQuestionarie = async (resource, data) => {
  let user;
  await resource
    .post(`api/${localStorage.getItem('perfil')}/user_questionary`, data)
    .then(
      (response) => {
        console.log(response);
        user = response.body.user;
      },
      (response) => {
        console.log(response);
      }
    );
  return user;
}

export const storeUserQuestionariePublic = async (resource, data) => {
  let user;
  await resource
    .post(`api/user_questionary`, data)
    .then(
      (response) => {
        console.log(response);
        user = response.body.user;
      },
      (response) => {
        console.log(response);
      }
    );
  return user;
}

export const getAnswersByQuestionryId = async (resource,id) => {
  let user;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/user_questionary/find_by_questionary_id/${id}`)
    .then(
      (response) => {
        console.log(response);
        user = response.body.user;
      },
      (response) => {
        console.log(response);
      }
    );
  return user;
}